import styled from 'styled-components';

export const ClickContent = styled.div`
  &:hover {
    cursor: pointer;
  }
`;

export const HeaderContent = styled.div`
  padding: 1rem;
  font-weight: bold;
  font-size: 14;
  letter-spacing: 1px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  justify-content: center;
  width: 100%;
`;

export const HeaderText = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const LogoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1em;
  padding: 0;
`;
